import { customAxios, STOCK_URL } from '../constants';
import { FETCH_USOS, FETCH_LISTA_USOS, CLEAR_USOS,FETCH_USO_GET } from './types';
import { evalAction, serverError } from '../utils/actionError';

export function fetchUsos(proformas) {
  const promises = [];
  proformas.map((proforma) => {
    const config = {
      params: {
        codAreaVta: proforma.codAreaVta,
        codFamiliaVeh: proforma.codFamilia,
      },
    };
    return (
    promises.push(
      customAxios.get(`${STOCK_URL}/maestros/usos-vehiculo`, config).then(response => ({
        [proforma.nroProforma]: response.data.listadoUsosVeh,
      })),
    ));
  });

  const request = Promise.all(promises);

  return {
    type: FETCH_USOS,
    payload: request,
  };
}

export function clearUsos() {
  return {
    type: CLEAR_USOS,
  };
}

export function fetchListaUsos(proformas) {
  const promises = [];
  proformas.map((proforma) => {
    const config = {
      params: {
        codAreaVta: proforma.codAreaVta,
        codFamiliaVeh: proforma.codFamiliaVeh,
      },
    };
    return (
    promises.push(
      customAxios.get(`${STOCK_URL}/maestros/usos-vehiculo`, config).then(response => ({
        [proforma.numProfVeh]: response.data.listadoUsosVeh,
      })),
    ));
  });

  const request = Promise.all(promises);

  return {
    type: FETCH_LISTA_USOS,
    payload: request,
  };
}

export function fetchUsoGet(codAreaVta,codFamiliaVeh) {
  const config = {
    params: {
      codAreaVta,
      codFamiliaVeh
    },
  };

  const request = customAxios.get(`${STOCK_URL}/maestros/usos-vehiculo`, config)
  .then(({ data }) => evalAction(data, 'listar'))
  .catch(error => serverError(error, 'listar'))

  return {
    type: FETCH_USO_GET,
    payload: request,
  };
}



// WEBPACK FOOTER //
// ./src/actions/Usos.js